import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { MyRecommendations } from '@widgets/matchmaker/MyRecommendations';

export const Route = createFileRoute('/matchmaker/recommendations')({
  component: Component,
});

export default function Component() {
  useTelegramBackButton({ to: 'back' });

  return (
    <Page>
      <MyRecommendations />
    </Page>
  );
}
